import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ModelNotification\ReadModelNotificationController::__invoke
* @see app/Http/Controllers/ModelNotification/ReadModelNotificationController.php
* @route '/api/model-notification/{modelNotification}/change-read-model-notification'
*/
const ReadModelNotificationController = (args: { modelNotification: string | number | { id: string | number } } | [modelNotification: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: ReadModelNotificationController.url(args, options),
    method: 'put',
})

ReadModelNotificationController.definition = {
    methods: ["put"],
    url: '/api/model-notification/{modelNotification}/change-read-model-notification',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\ModelNotification\ReadModelNotificationController::__invoke
* @see app/Http/Controllers/ModelNotification/ReadModelNotificationController.php
* @route '/api/model-notification/{modelNotification}/change-read-model-notification'
*/
ReadModelNotificationController.url = (args: { modelNotification: string | number | { id: string | number } } | [modelNotification: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { modelNotification: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { modelNotification: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            modelNotification: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        modelNotification: typeof args.modelNotification === 'object'
        ? args.modelNotification.id
        : args.modelNotification,
    }

    return ReadModelNotificationController.definition.url
            .replace('{modelNotification}', parsedArgs.modelNotification.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ModelNotification\ReadModelNotificationController::__invoke
* @see app/Http/Controllers/ModelNotification/ReadModelNotificationController.php
* @route '/api/model-notification/{modelNotification}/change-read-model-notification'
*/
ReadModelNotificationController.put = (args: { modelNotification: string | number | { id: string | number } } | [modelNotification: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: ReadModelNotificationController.url(args, options),
    method: 'put',
})

export default ReadModelNotificationController